// extracted by mini-css-extract-plugin
export default {"card":"Contacts_card__cuUHl","links":"Contacts_links__LbbPF","info":"Contacts_info__OXXi9"};